import React from "react";
/** @jsxImportSource @emotion/react */
import { css } from "@emotion/react";

//CONSTANTS
import { MOBILE } from "../../constants/breakpoints";

//Components
import HeroButton from "../../components/HeroButton";
import HeroMobileButton from "../../components/HeroMobileButton";

//Assets
import hero_img from "./../../assets/hero_img.svg";
import mobile_hero from "../../assets/mobile_hero.png";
import { openAssetInput, openWallet } from "../../redux/walletReducer";
import { useSelector, useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { RootState } from "../../redux/store";
import WhiteListedCollectionsHome from "../../components/WhiteListedCollectionHome";

function Hero() {
  const navigate = useNavigate();
  let wallet = useSelector((state: RootState) => state.walletState);
  let dispatch = useDispatch();

  const mintProxyTokenBtnHandler = () => {
    if (wallet.address && wallet.address.length !== 0) {
      if (wallet.assetAddress && wallet.assetAddress.length !== 0) {
        navigate(`/assets/${wallet.assetChain}/${wallet.assetAddress}`);
      } else {
        dispatch(openAssetInput());
      }
    } else {
      dispatch(openWallet());
    }
  };

  return (
    <section
      css={css`
        display: flex;
        width: 1140px;
        height: 900px;
        margin: 0 auto;
        align-items: center;

        @media (max-width: ${MOBILE}px) {
          width: 100%;
          height: fit-content;
          flex-direction: column;
          margin: 0 auto;
          margin-bottom: 133.8px;
          margin-top: 33px;
        }
      `}
    >
      <div
        css={css`
          width: 600px;
          z-index: 100;
          @media (max-width: ${MOBILE}px) {
            width: 100%;
            display: flex;
            flex-direction: column;
            align-items: center;
          }
        `}
      >
        <img
          css={css`
            display: none;
            @media (max-width: ${MOBILE}px) {
              display: block;
              width: 100%;
              margin-bottom: 44.8px;
            }
          `}
          src={mobile_hero}
          alt=""
        />
        <h1
          css={css`
            font-weight: 400;
            font-size: 86px;
            font-style: italic;
            width: 656px;
            margin: 0;

            @media (max-width: ${MOBILE}px) {
              font-size: 40px;
              width: 345px;
              text-align: center;
            }
          `}
        >
          <span
            css={css`
              font-weight: 900;
              font-style: normal;
            `}
          >
            Trust
          </span>{" "}
          NO ONE not{" "}
          <span
            css={css`
              font-weight: 900;
              font-style: normal;
            `}
          >
            even us...
          </span>
        </h1>
        <p
          css={css`
            width: 559px;
            font-weight: 400;
            font-size: 24px;
            z-index: 100;
            position: relative;

            @media (max-width: ${MOBILE}px) {
              font-size: 16px;
              width: 345px;
              text-align: center;
            }
          `}
        >
          Introducing the only trustless verification tool. A patented product
          that mitigates phishing while securing your assets
        </p>

        <HeroButton onClick={mintProxyTokenBtnHandler}>
          Mint Proxy Token
        </HeroButton>

        <HeroMobileButton onClick={mintProxyTokenBtnHandler}>
          Mint Proxy Token
        </HeroMobileButton>
      </div>
      <div
        css={css`
          width: 626px;
          height: 672px;

          @media (max-width: ${MOBILE}px) {
            width: 100%;
            display: none;
          }
        `}
      >
        {/* <img src={hero_img} alt="" /> */}
        <WhiteListedCollectionsHome></WhiteListedCollectionsHome>
      </div>
    </section>
  );
}

export default Hero;
